import compact from 'lodash/compact'
import memoize from 'lodash/memoize'
import validators from './validation'

let createValidator = (validators, validator, options) => {
  if (validators[validator]) {
    return validators[validator](options)
  }
}

createValidator = memoize(createValidator, (...args) => JSON.stringify(args))

export const createValidatorsFromProps = props => {
  const validatorNames = (props.validator || '').split(',')

  return compact(
    validatorNames.map(name =>
      createValidator(
        validators,
        name.trim(),
        props[`validator-${name.trim()}`],
      ),
    ),
  )
}

/**
 * Allows us to add custom error messages that may be too specific to include
 * in the specific validators.js file
 *
 * @param {Map} values the current form values that we are checking
 * @param {array} validators a list of objects that include the name, errorMessage, and
 *                            isFieldValid callback function to determine if the error exists
 * @returns {object} errors - returns back an object of errors with the field names as the keys
 */

export const addCustomValidators = (values, validators = []) => {
  const errors = {}

  validators.forEach(({ name = '', errorMessage, isFieldInvalid }) => {
    const fieldValue = values.getIn(name.split('.'))
    if (isFieldInvalid(fieldValue)) {
      errors[name] = errorMessage
    }
  })

  return errors
}



// WEBPACK FOOTER //
// ./src/sidecar-utils/lib/enhancers/toReduxFormField/helpers.js